import React from 'react';
import styled from 'styled-components';
import { IEurReportState } from '../../../data/providers/reports/eurReportProvider';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf, shouldInvert } from '../../shared/pdf/Pdf';
import { EurGraph } from './EurGraph';

interface IProps {
  reportState: IEurReportState;
  pdfMode?: EPdfMode;
}

export const EurGraphCard = (props: IProps): React.ReactElement => {
  return (
    <PdfCardWrapper className='avoid-break' pdf={isPdf(props.pdfMode)}>
      <Notable pdf={isPdf(props.pdfMode)}>
        <Card
          inverse={shouldInvert(props.pdfMode)}
          style={isPdf(props.pdfMode) ? { overflow: 'visible', height: 'auto' } : undefined}
        >
          <Column>
            <CardBody withoutFooter notScrollable={isPdf(props.pdfMode)}>
              <EurGraph
                results={props.reportState.resultList}
                pdfMode={props.pdfMode}
              />
            </CardBody>
          </Column>
        </Card>
      </Notable>
    </PdfCardWrapper>
  );
};

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
  padding: 2px;
`;
